import { render, staticRenderFns } from "./formlyTextLabel.vue?vue&type=template&id=4e3cbe68&scoped=true&"
import script from "./formlyTextLabel.vue?vue&type=script&lang=ts&"
export * from "./formlyTextLabel.vue?vue&type=script&lang=ts&"
import style0 from "./formlyTextLabel.vue?vue&type=style&index=0&id=4e3cbe68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3cbe68",
  null
  
)

export default component.exports